import { Utils } from 'cc-common';
import { Exclude } from 'class-transformer';

export class AddressRawDto {
    addressId: number;
    address01: string;
    address02: string;
    address03: string;
    careOf: string;
    countryCode = 'US';
    state: string;
    city: string;
    postalCode: string;

    @Exclude()
    stateCode: string;

    @Exclude()
    country = 'United States';

    get addressText(): string {
        return [this.address01, this.city, this.state, this.postalCode]
            .filter((t) => Utils.notNullOrEmpty(t))
            .join(', ');
    }

    toString(): string {
        return [
            this.address01 || '',
            this.address02 || '',
            this.address03 || '',
            this.city,
            this.state,
            this.postalCode
        ]
            .filter((token) => Utils.notNullOrEmpty(token))
            .join(', ');
    }
}
